<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">走访信息</div>
      </div>
    </div>

    <SearchComponent
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
    ></SearchComponent>

    <el-card class="box-card">
      <el-descriptions title="">
        <el-descriptions-item :label="`已选择(${multipleSelection.length})`" :labelStyle="{'min-width': '90px','margin': '5px 0'}">
          <el-tag
            v-for="(tag, index) in multipleSelection"
            :key="index"
            closable
            type="info"
            @close="handleSelect('', tag)"
          >
            {{tag.plantationBizNo}}-{{tag.plantationName}}-{{tag.cultivationMethodSpecValueKey}}-{{ tag.cropAgeValue }}年
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <TablePublic
      ref="listTable"
      :colLists="colLists"
      :tableData="tableData"
      :selseflag="true"
      @handleSelect="handleSelect"
      @handleSelectAll="handleSelectAll"
      :pageParams="queryParams" 
      @pageChange="getList"
      :total="total"
      :cell-style="cellStyle"
    >
      <template slot="solts" slot-scope="scope">
        <el-button @click="delrow(scope.data, scope.$index)" type="text" size="small" class="delbutton">删除</el-button>
      </template>
    </TablePublic>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/statusConstants'
import { mapState } from 'vuex'
import { getPickManageList, getDropPlantationList } from '@/api/system/manage'
import TablePublic from '@/components/tablePublic'
import SearchComponent from '@/components/searchComponent'
export default {
  components: { TablePublic, SearchComponent },
  data() {
    return {
      dialogVisible: false,
      colLists: [
        {
          prop: 'plantationBizNo',
          label: '果园编号',
          isTrue: true,
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
        },
        {
          prop: 'locName',
          label: '果园区域',
          isTrue: true,
        },
        {
          prop: 'pesticideTestResult',
          label: '农残',
          isTrue: true,
        },
        {
          prop: 'heavyMetalTestResult',
          label: '重金属',
          isTrue: true,
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄（年）',
          isTrue: true,
        },
        {
          prop: 'occupiedArea',
          label: '果树亩数（亩）',
          isTrue: true,
        },
        {
          prop: 'estimatedUnitOutput',
          label: '预估亩产量（斤）',
          isTrue: true,
        },
        {
          prop: 'estimatedTotalOutput',
          label: '预估总产量（斤）',
          isTrue: true,
        },
        {
          prop: 'estimatedUnitPrice',
          label: '预售单价（元）',
          isTrue: true,
        },
        {
          prop: 'fertilizerTypeKeyValue',
          label: '施肥种类',
          isTrue: true,
        },
        {
          prop: 'fieldTypeKeyValueList',
          label: '土地性质',
          isTrue: true,
        },
        {
          prop: 'ownerName',
          label: '园主/场长',
          isTrue: true,
        },
        {
          prop: 'ownerContact',
          label: '联系方式',
          isTrue: true,
        },
        {
          prop: 'lastUpdateOperatorName',
          label: '品控人员',
          isTrue: true,
        },
        {
          prop: 'lastVisitDate',
          label: '走访日期',
          isTrue: true,
          width: '100'
        },
      ],
      queryParams: {},
      tableData: [],
      selectionChange: [],
      selectAction: true,
      total: 0,
      selectOrInputList: [
        {
          model: 'cultivationMethodSpecAttrKeys',
          placeholder: '请选择培育方式',
          value: 'cultivationMethodSpecAttrKey',
          label: 'cultivationMethodSpecValueKey',
          list: [],
          type: 'select',
        },
        {
          model: 'plantationId',
          placeholder: '请选择果园',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'pesticideTestPassedStatus',
          placeholder: '请选择农残检测结果',
          value: 'value',
          label: 'label',
          list: CONSTANTS.pesticideTestPassedStatus1,
          type: 'select',
        },
        {
          model: 'heavyMetalTestPassedStatus',
          placeholder: '请选择重金属检测结果',
          value: 'value',
          label: 'label',
          list: CONSTANTS.heavyMetalTestPassedStatus1,
          type: 'select',
        },
      ],
      multipleSelection:[], // 用于存储选中行的键值对
    }
  },
  computed: {
    ...mapState({
      purchasePlanData: (state) => state.manage.infoDetail || {},
      dictList: (state) => state.system.dictList || [],
    }),
  },
  created() {
    if(this.purchasePlanData){
      this.selectOrInputList[0].list = this.uniqueArr(this.purchasePlanData.itemRespList, 'cultivationMethodSpecAttrKey')
    }
  },
  methods: {
    // 数据更新时保存选中状态
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    isFlag(d, row){
      const conditionEums = ['plantationId', 'cultivationMethodSpecAttrKey', 'cropAgeValue']
      return conditionEums.every(key => d[key] == row[key])
    },
    handleSelect(selection, row) {
      const obj = this.tableData.find(d=>this.isFlag(d, row))
      const index = this.multipleSelection.findIndex(d=>this.isFlag(d, row))
      if (index === -1) {
        this.multipleSelection.push(obj);
      }else{
        this.$refs.listTable.handleCancelRowSelection(obj);
        this.multipleSelection.splice(index, 1);
      }
    },
    handleSelectAll(selection) {
      if (selection && selection.length) {
        this.multipleSelection = this.deepClone(this.tableData);
      } else {
        this.multipleSelection = [];
      }
    },
    async getForInit(rows){
      this.queryStatus = false
      this.multipleSelection = this.deepClone(rows);
      this.getDropPlantations()
      this.getList()
    },
    setRowSelection(){
      this.$nextTick(() => {
        this.multipleSelection.forEach(row => {
          let exists = this.tableData.find(d=>this.isFlag(d, row))
          if(exists){
            this.$refs.listTable.handleOpenRowSelection(exists);
          }
        });
      });
    },
    getDropPlantations() {
      getDropPlantationList({
        readyForHarvestStatus: 1,
      }).then((res) => {
        if (res.flag) {
          this.selectOrInputList[1].list = res.data
        }
      })
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      if(!this.queryStatus){
        const cultivationMethodSpecAttrKeys = this.uniqueArr(this.purchasePlanData.itemRespList, 'cultivationMethodSpecAttrKey')
        this.queryParams.cultivationMethodSpecAttrKeys = cultivationMethodSpecAttrKeys.map(d=>d.cultivationMethodSpecAttrKey).join(',')
      }
      getPickManageList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items && res.data.items.map(item=>{
              item.locName = this.formatLocal(item.locDetails, 3)
              item.lastVisitDate = this.parseTime(item.lastVisitTime, '{y}-{m}-{d}')
              item.cropBrandKeyValue = this.formatDictToText(item.cropBrandKey,'productType',this.dictList)
              item.fieldTypeKeyValueList = this.formatDictToText(item.fieldTypeKeyList,'landStatus',this.dictList)
              item.fertilizerTypeKeyValue = this.formatDictToText(item.fertilizerTypeKey,'fertilizerType',this.dictList)
              item.pesticideTestResult = CONSTANTS.getStatusConversion(item.pesticideTestPassedStatus, 'pesticideTestPassedStatus')
              item.heavyMetalTestResult = CONSTANTS.getStatusConversion(item.heavyMetalTestPassedStatus, 'heavyMetalTestPassedStatus')
              return item
            })
            this.total = res.data.totalCount
            this.setRowSelection()
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    submit() {
      return new Promise((resolve, reject) => {
        if (!this.multipleSelection.length) {
          this.$message.error('请新增至少一条计划信息')
          return reject()
        }
        resolve(this.multipleSelection)
      })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      console.log(columnIndex)
      if (
        this.parseTime(row.lastVisitTime, '{y}') == new Date().getFullYear() &&
        columnIndex == 18
      ) {
        return {
          background: '#e1f3d8',
        }
      }
    },
    reset() {},
    editHistory() {
      this.dialogVisible = true
    },
    addrow() {
      this.tableData.push({
        code: 'xxx',
        oilCode: 'xxxxxx',
        createTime: '2024',
      })
    },
    beforeAvatarUpload() {},
    handleAvatarError() {},
    handlePropress() {},
    handleAvatarSuccess() {},
    handleDel() {},
    handleDelFile() {},
    async handleSearch(query) {
      this.queryStatus = true
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryStatus = false
      this.queryParams = {
        pageNo: 1
      }
      this.getList()
    },
  },
}
</script>

<style scoped lang="less">
@import '../../../../assets/form.less';
/deep/ .el-card{
  margin-bottom: 10px;
  .el-card__body{
    padding: 10px;
    .el-descriptions-item{
      padding: 0;
    }
  }
}
/deep/ .el-tag{
  margin: 5px 0;
  margin-right: 10px;
  color: #000 !important;
}

/deep/ .el-descriptions-item__container .el-descriptions-item__content{
  flex-wrap: wrap;
}
</style>
